// Sub-hooks for TaskItemBase controller: local completion state and drag-and-drop sortable wiring.
import { useState, useEffect } from 'react';
import { useSortable } from '@dnd-kit/sortable';

import { getDragConfig } from '@/features/tasks/utils/ui/taskListItemUtils';

export function useTaskItemLocalCompleted(task) {
  const [localCompleted, setLocalCompleted] = useState(
    task?.completed ?? false,
  );

  useEffect(() => {
    setLocalCompleted(task?.completed ?? false);
  }, [task?.completed]);

  return [localCompleted, setLocalCompleted];
}

export function useTaskItemSortableSetup({
  task,
  isRollup,
  view,
  dragEnabled,
  listId,
  dragType,
  isSchedulable,
  indentationType,
  variant,
}) {
  const { isDragDisabled, sortableId, dndType } = getDragConfig(
    task,
    isRollup,
    view,
    dragEnabled,
    listId,
    dragType,
    isSchedulable,
    indentationType,
  );

  const sortable = useSortable({
    id: sortableId,
    data: { task, type: dndType, view, indentationType, variant },
    disabled: isDragDisabled,
  });

  return { isDragDisabled, ...sortable };
}
